import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FileService } from '../../shared/fileService';
import { TuftService } from '../tuft-dashboard/tuft.service';

@Component({
  selector: 'app-calendar-report',
  templateUrl: './calendar-report.component.html',
  styleUrls: ["../../main/tuft-dashboard/tuft-dashboard/tuft-dashboard.component.scss"]
})
export class CalendarReportComponent implements OnInit {
    studyId:string = "";
    oid:string = "";
    studyNumber = "";
    calendarName = "";
    reportData = [];
    reportHeaders = [];
    isLoading:boolean = false;

  constructor(private route: ActivatedRoute,private tuftDashboard:TuftService,private fileService:FileService ) { }

  ngOnInit() {
    this.route.queryParams.subscribe((param) => {
        this.studyId = param["studyId"];
        this.oid = param["oid"];
        this.studyNumber = param["studyNumber"];
        this.calendarName = param["calendarName"];
      this.getCalendarReportList()
    });
  }

  getCalendarReportList() {
    this.isLoading = true;
    let query = `studyId=${this.studyId}&calendarOID=${this.oid}`;
    this.tuftDashboard.getCalendarReportListApi(query).subscribe(
      (res) => {
        if (res["message"] == "Success") {
          this.isLoading = false;
          this.reportData = res.data.report;
          this.reportHeaders = res.data.headers
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  exportAsXLSX(): void {
    var todayTime = new Date();
    let currentTimeEpoch = Date.now();
    let date = new Date(currentTimeEpoch);
    var month = date.getMonth() + 1;
    var day = date.getDate();
    var year = date.getFullYear();

    this.fileService.exportAsExcelFile(this.reportData,month + "/" + day + "/" + year);
  }

}
